// Ícono minimalista del header de módulo con colores brand PD Travel.
// Uso: <ModuleHeaderIcon icon={SomeIcon} /> justo antes del <h1> del módulo.
export function ModuleHeaderIcon({ icon: Icon, className = "" }) {
  return (
    <div
      className={`w-11 h-11 rounded-xl border border-[#0037ff]/15 bg-[#0037ff]/5 flex items-center justify-center flex-shrink-0 ${className}`}
    >
      <Icon className="w-5 h-5 text-[#0037ff]" strokeWidth={1.75} />
    </div>
  );
}
